export default class CustomerBlockEnum {
    static BLOCK_LIST = '[data-element="customer-block-list"]'
    static BLOCK_LIST_CARD_INFOBOX = '[data-element="customer-block-list"] .iris-card--infobox'
    static BLOCK_LIST_MAP_TRIGGER = '[data-trigger="customer-block-list-map-button"]'
    static BLOCK_LIST_ENGINE_TRIGGER = '[data-trigger="customer-block-list-engine-button"]'
}
